import React from 'react';
import './App.css'; // Assuming your CSS file
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

const Service12 = () => {
    const navigate = useNavigate(); // Initialize navigate

    // Function to handle navigation
    const handleNavigate = () => {
        navigate('/galleries'); // Navigate to the gallery page
    };

    return (
        <div className="about-events-container">
            {/* First section for images and content */}

                <div className="about-events-images">
                    <img src="/images/weddd.webp"  />
                    <img src="/images/wedd3.webp"  />
                    <img src="/images/pacl7.webp" />
                    <img src="/images/01.webp" />
                </div>

                <div className="about-events-content">
                    <h2 className="about-header-service">Bring Your Own Catering</h2>

                    <p className="about-events-description">
                        At Cocoloco Garden, we offer you the flexibility to celebrate your special moments just the way you like!
                        Whether you're hosting a family gathering, corporate event, birthday party, wedding reception, or any other
                        special occasion, you can bring your preferred catering service to create a personalized dining experience.
                    </p>

                    <p className="about-events-description">
                        Enjoy the freedom to curate your own menu with your favorite dishes, whether it's traditional Sri Lankan cuisine,
                        international flavors, or a mix of both. Our spacious and scenic venue provides the perfect backdrop for your event,
                        ensuring a memorable experience for you and your guests.
                    </p>

                    <button className="service-button" onClick={handleNavigate}>
                        Click Here To See More Gallery ..
                    </button>
                </div>

        </div>
    );
};

export default Service12;
